export default __webpack_public_path__ + "bf7d11b17f85f0181710e4c28be8174b.webp";